export enum InvenTypeVo {
  Recent = 'recent',
  Paid = 'paid',
  Like = 'like',
}
